import * as React from 'react';



export default class WorkkardActivity extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="17" viewBox="0 0 16 16" fill="none">
        <rect width="0" height="0" fill="white"/>
        <rect x="3.5" y="1.5" width="11" height="11" rx="0.5"/>
        <path d="M2.5 3H2C1.44772 3 1 3.44772 1 4V14C1 14.5523 1.44772 15 2 15H12C12.5523 15 13 14.5523 13 14V13.5"/>
        <path d="M6.5 10L9 4L11.5 10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7 8H11" strokeLinejoin="bevel"/>
      </svg>
    )
  }
}
